import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';


export default function ViewMoreToggler (props) {
  const {
    onClickViewMore,
    canRenderViewMore,
    disableViewMore
  } = props;

  return canRenderViewMore ?
    (
      <Button
        onClick={onClickViewMore}
        disabled={disableViewMore}
        buttonConfig={{ type: 'link', size: 'xs', label: 'View more', color: 'blue', e2eName: 'view-more' }}
      />
    ) :
    null;
}

ViewMoreToggler.propTypes = {
  onClickViewMore: PropTypes.func.isRequired,
  canRenderViewMore: PropTypes.bool.isRequired,
  disableViewMore: PropTypes.bool.isRequired,
};
